<template>
	<resource-list :api="getApiPath()" resource="story"></resource-list>
</template>

<script>
import Resource from './Resource';

export default {

  name: 'CollectionList',

  props: {
  	id: String,
  },
  components: {
  	'resource-list': Resource,
  },
  methods: {
  	getApiPath: function() {
  		return `/admin/api/collection/${this._props.id}`;
  	}
  }
};
</script>

<style lang="css" scoped>
</style>
